import { getDoctorSessionCacheKey } from '../../utils/authSession';
import axios from '../../scenes/utils/axiosInstance';
export const aiEvents = { open: 'patientmesh:context-ai', updated: 'patientmesh:context-ai-updated' };
const summaries = new Map();
let owner = null;
function checkOwner() { const current = getDoctorSessionCacheKey(); if (owner !== current) { summaries.clear(); owner = current; } }
export const contextKey = context => JSON.stringify(context || {});
export function rememberAiSummary(context, data) {
  checkOwner();
  if (data?.status === 'completed' && data.summary) {
    summaries.set(contextKey(context), data);
    if (data.kind === 'ml_result' && data.sources?.length === 1 && data.sources[0].jobId) summaries.set(contextKey({ kind: 'ml_result', jobId: data.sources[0].jobId }), data);
    window.dispatchEvent(new CustomEvent(aiEvents.updated));
  } else summaries.delete(contextKey(context));
}
export function getAiSummary(context, locale) {
  checkOwner();
  const data = summaries.get(contextKey(context));
  return data?.locale === locale ? data : null;
}
export function sourceRef(result) { return result?.ai_source_ref || result?.data?.ai_source_ref || result?.result?.ai_source_ref || null; }
export function sourceContext(kind, result) {
  // Use the persisted ML run across report, project and publication screens.
  const mlJobId = result?.job_id || result?.run_id || result?.data?.job_id || result?.result?.job_id;
  if (kind === 'ml_result' && /^[a-f0-9]{8}-(?:[a-f0-9]{4}-){3}[a-f0-9]{12}$/i.test(mlJobId || '')) return { kind, jobId: mlJobId };
  const jobId = result?.stat_job_id || result?.result?.stat_job_id || result?.data?.stat_job_id;
  if (jobId && ['stats_result', 'feature_impact'].includes(kind)) return { kind, jobId };
  const ref = sourceRef(result);
  return ref ? { kind, sourceRef: ref } : null;
}
const contextAiService = {
  capabilities: () => axios.get('/api/ai/analyses/capabilities').then(r => r.data),
  cache: (context, locale) => axios.get('/api/ai/analyses/cache', { params: { context: JSON.stringify(context), locale } }).then(r => r.data),
  preview: (context, locale, redactions = [], force = false) => axios.post('/api/ai/analyses/preview', { context, locale, redactions, force }).then(r => r.data),
  generate: (id, approved_hash) => axios.post(`/api/ai/analyses/${id}/generate`, { approved_hash }).then(r => r.data),
  get: id => axios.get(`/api/ai/analyses/${id}`).then(r => r.data),
  cancel: id => axios.post(`/api/ai/analyses/${id}/cancel`).then(r => r.data),
};

export default contextAiService;
